/* import __COLOCATED_TEMPLATE__ from './selected-collection.hbs.js'; */
import Component from "@ember/component";
import { computed } from "@ember/object";
import { reads } from "@ember/object/computed";
import { tagName } from "@ember-decorators/component";
const SelectedCollection = dt7948.c(class SelectedCollection extends Component {
  static {
    dt7948.g(this.prototype, "selectedTags", [reads("collection.content.selectedTags.[]")]);
  }
  #selectedTags = (dt7948.i(this, "selectedTags"), void 0);
  get tags() {
    if (!this.selectedTags) {
      return [];
    }
    let tags = this.selectedTags;
    if (tags.length >= 20 && this.selectKit.filter) {
      tags = tags.filter(t => t.includes(this.selectKit.filter));
    } else if (tags.length >= 20) {
      tags = tags.slice(0, 20);
    }
    return tags.map(selectedTag => {
      return {
        value: selectedTag,
        classNames: "selected-tag"
      };
    });
  }
  static {
    dt7948.n(this.prototype, "tags", [computed("selectedTags.[]", "selectKit.filter")]);
  }
}, [tagName("")]);
export default SelectedCollection;